import store from '@/redux';
import config from '@/server/config';
import request from '@/server/request';
import * as React from 'react';
import * as FormulaStore from '@/redux/pages/formula';
import * as ProductStore from '@/redux/pages/product-edit';

const Toast = require('react-toast-mobile');

interface IProps { 
    key?: string;
    type: number;
    data: any;
    history: any;
    showReason(): void;
    remove(): void;
    delete(): void;
}

export default class Item extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            id: [this.props.data.details_id, this.props.data.details_log_id, this.props.data.details_log_id, this.props.data.details_id, this.props.data.formula_id][this.props.type - 1]
        }
    }
    public render() {
        return (
            <div className="ylk-pro-item">
                <div className="ylk-pro-iteminfo" onClick={() => this.navigateToDetail()}>
                    <div className="ylk-pro-iname">
                        <strong>{this.props.type === 5 ? this.props.data.formula_name : this.props.data.product_name}</strong>
                        {
                            this.props.type === 2 || this.props.type === 3 ?
                                <p className={this.props.data.product_review === '2' ? 'status-fail' : ''}>{this.props.data.product_review2}</p>
                            : null
                        }
                    </div>
                    {
                        this.props.type === 5 ?
                        <div className="ylk-pro-iattr">
                                <p>{this.props.data.formula_company}</p>
                                <p>{this.props.data.adhibition_type}</p>
                        </div> :
                        <div className="ylk-pro-iattr">
                                {this.props.data.cas_number ? <p>CAS: {this.props.data.cas_number}</p> : null}
                                {this.props.data.chemical_name ? <p>化学名称：{this.props.data.chemical_name}</p> : null}
                        </div>
                    }
                    <div className="ylk-pro-iattr">
                        <p>{this.props.type === 5 ? this.props.data.created_at : this.props.data.create_at}</p>
                    </div>
                </div>
                <div className="ylk-pro-itembtns">
                    {
                        this.renderBtns()
                    }
                    
                </div>
            </div>
        )
    }

    /**
     * 渲染按钮
     * @return {JSXELement} 按钮结构
     */
    private renderBtns() { 
        return (
            <dl>
                <dt>
                    {
                        (this.props.type === 2 || this.props.type === 3) && this.props.data.product_review === '2' ?
                            <span onClick={() => this.props.showReason()}>拒绝理由</span>
                            : null
                    }
                </dt>
                <dd>
                    {
                        this.props.type === 2 || this.props.type === 3 ? <span onClick={() => this.viewMyself()}>我的版本</span> : null
                    }
                    {
                        this.props.type === 1 || this.props.type === 5 ? <span onClick={() => this.editAction()}>编辑</span> : null
                    }
                    {
                        this.props.type === 1 ? <span className="btn-delete" onClick={() => this.props.remove()}>移除</span> : null
                    }
                    {
                        this.props.type !== 1 ? <span className="btn-delete" onClick={() => this.props.delete()}>删除</span> : null
                    }
                    
                </dd>
            </dl>
        )
    }

    // 跳转到各详情
    private navigateToDetail() { 
        let url = '';
        if (this.props.type === 5) {
            url = `${config.MULKAPI}/#/formuladetails?formula_id=${this.state.id}`;
        } else { 
            url = `${config.MULKAPI}/#/prodetail?id=${this.props.data.details_id}&munufacturer_id=${this.props.data.munufacturer_id}&status=${this.props.data.product_review}`;
        }
        window.location.href = url;
    }

    // 编辑
    private editAction() { 
        Toast.T.loading();
        if (this.props.type === 5) {
            this.getInitData(() => {
                Toast.T.loaded();
                this.props.history.push(`/u/formula?id=${this.state.id}`);
            });
        } else { 
            this.getProInitData(() => { 
                Toast.T.loaded();
                this.props.history.push(`/u/product/edit?id=${this.state.id}&type=${this.props.data.product_equipment}&source=${this.props.type === 1 ? 3 : 2}`);
            });
        }
    }

    // 获取商品初始化数据
    private async getProInitData(callback: any) { 

        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/product/get-goods&id=${this.state.id}&source=3`
        });

        if (r.error_code === 0) { 
            const data = r.data;
            const provinceList = await request({
                url: `${config.ULKAPI}api/web/index.php?r=index/regions&pCode=1`
            });
            if (provinceList.error_code === 0) { 
                const obj = provinceList.data;
                for (let i = 0; i < obj.length; i++) {
                    if (data.PROVINCE == obj[i].id) { 
                        data.provinceName = obj[i].name;
                        const cityList = await request({
                            url: `${config.ULKAPI}/api/web/index.php?r=index/regions&pCode=${obj[i].id}`
                        });
                        for (let j = 0; j < cityList.data.length; j++) {
                            if (data.CITY == cityList.data[j].id) { 
                                data.cityName = cityList.data[j].name;
                            }
                        }
                    }
                }
            }

            const proCategory: any[] = [
                {
                    lv1: {},
                    lv2: {},
                    lv3: {}
                }
            ];
            const appCategory: any[] = [
                {
                    lv1: {},
                    lv2: {},
                    lv3: {},
                    lv4: {},
                }
            ];
            const parameter: any[] = [
                {
                    id: '', // 物性值id
                    name: '', // 名称
                    physical: '', // 物性值
                    unit: '', // 单位
                    unitId: '', // 单位id
                    remarks: '', // 备注
                }
            ];

            // 产品分类
            if (data.product_cate_one) { 
                data.product_cate_one.forEach((v: any, k: number) => { 
                    const name = data.product_cate_name[k] ? data.product_cate_name[k].split('>') : [];
                    proCategory[k] = {
                        lv1: {
                            product_id: v,
                            classification_name: name[0] || ''
                        },
                        lv2: {
                            product_id: data.product_cate_two[k],
                            classification_name: name[1] || ''
                        },
                        lv3: {
                            product_id: data.product_cate_three[k],
                            classification_name: name[2] || ''
                        }
                    };
                });
            }

            // 应用分类
            if (data.application_cate_one) { 
                data.application_cate_one.forEach((v: any, k: number) => { 
                    const name = data.application_cate_name[k] ? data.application_cate_name[k].split('>') : [];
                    appCategory[k] = {
                        lv1: {
                            id: v,
                            classification_name: name[0] || ''
                        },
                        lv2: {
                            id: data.application_cate_two[k],
                            classification_name: name[1] || ''
                        },
                        lv3: {
                            id: data.application_cate_three[k],
                            classification_name: name[2] || ''
                        },
                        lv4: {
                            id: data.application_cate_four[k],
                            classification_name: name[3] || ''
                        }
                    };
                });
            }

            // 物性参数
            if (data.product_physical && data.product_physical.length) { 
                data.product_physical.forEach((v: any, k: number) => { 
                    parameter[k] = {
                        id: v.id,
                        name: v.nature, 
                        physical: v.units,
                        unit: v.unit, 
                        unitId: v.unit_id,
                        remarks: v.condition, 
                    };
                });
            }

            const initData: ProductStore.IProductEditState = {
                step: 1,
                proCategory,
                appCategory,
                productName: data.PRODUCT_NAME || '',
                productEnName: data.PRODUCT_ENGLISH_NAME || '',
                chemicalName: data.CHEMICAL_NAME || '',
                chemicalFormula: data.MOLECULAR_FORMULA || '',
                molecular: data.MOLECULAR_WEIGHT || '',
                cas: data.CAS_NUMBER || '',
                desc: data.PRODUCT_DESCRIPTION || '',
                munufacturer_id: data.MUNUFACTURER_ID || '',
                munufacturer_name: data.MUNUFACTURER_NAME || '',
                munufacturer_abbreviation: data.MUNUFACTURER_ABBREVIATION || '',
                brand: data.BRAND || '',
                model: data.GRADE || '',
                country: data.FOREIGN_ID || '',
                foreignAddress: data.FOREIGN_ADDRESS || '',
                addressInfo: {
                    province: {
                        id: data.PROVINCE,
                        name: data.provinceName || ''
                    },
                    city: {
                        id: data.CITY,
                        name: data.cityName || ''
                    }
                },
                color: data.COLOUR || '',
                period: data.SHELF_LIFE || '',
                appearance: data.PHYSICAL_FORM || '',
                logo: data.LOGO || '',
                storage: data.STORAGE_CONDITION || '',
                performance: data.PRODUCT_CHARACTERISTICS || [''],
                tds: data.tdsUrl || '',
                msds: data.msdsUrl || '',
                parameter,
            }

            store.dispatch({
                type: ProductStore.types.INIT,
                initData,
            });

            if (callback) { 
                callback();
            }

        }
            
    }

    // 获取初始化数据
    private async getInitData(callback: any) {

        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/formula/get-formula&id=${this.state.id}`
        });

        if (r.error_code === 0) { 
            const data = r.data;
            const initData: FormulaStore.IFormulaStoreState = {
                name: data.FORMULA_NAME, 
                supplier: data.MUNUFACTURER_ID,
                supplierName: data.FORMULA_COMPANY,
                supplierAbbreviation: data.MUNUFACTURER_ABBREVIATION,
                component: [],
                component2: [],
                model: [],
                quality: [],
                introduction: data.FORMULA_INTRODUCE,
                process: data.TECHNOLOGICAL_PROCESS,
                guidance: data.CONSTRUCTION_GUIDANCE,
                labels: [],
                doc: data.FORMULA_PDF,
                logo: data.LOGO,
                appCategory: data.ADHIBITION_TYPE_VAL,
                appCateName: data.ADHIBITION_TYPE
            };
            data.fORMULACOMPONENTs.forEach((v: any) => { 
                initData.component.push({
                    name: v.GROUPING_NAME, 
                    value: v.GROUPING
                });
                initData.component2.push(v.DETAILS_NAME);
                initData.model.push(v.GRADE);
                initData.quality.push(v.RATIO);
            });
            data.label.forEach((v: any) => { 
                initData.labels.push(v.LABEL_ID);
            });
            store.dispatch({
                type: FormulaStore.types.INIT,
                initData,
            });
            if (callback) { 
                callback();
            }
        }

    }

    // 查看我的版本
    private viewMyself() { 
        store.dispatch({
            type: ProductStore.types.INPUT,
            data: {
                key: 'step',
                value: 1
            }
        });
        this.props.history.push(`/u/product/edit?id=${this.props.data.details_log_id}&type=${this.props.data.product_equipment}&source=4`);
    }

}